<template>
  <v-card>
    <v-container>
      <v-row justify="center">
        <v-img class="ma-2" max-width="300" src="/livesync_logo.png" />
      </v-row>
      <span class="font-weight-bold ml-4">Sign In</span>
      <v-card-text>
        <v-form>
          <v-text-field
            v-model="username"
            label="Email"
            required
            autocomplete="username"
            type="email"
            placeholder=" "
            ref="focusedField"
          ></v-text-field>
          <v-text-field
            :append-icon="show ? 'mdi-eye-off' : 'mdi-eye'"
            :type="show ? 'text' : 'password'"
            name="input-10-2"
            label="Password"
            v-model="password"
            autocomplete="current-password"
            class="input-group--focused"
            placeholder=" "
            @click:append="show = !show"
          ></v-text-field>
          <v-layout row class="bottom">
            <v-btn
              color="blue"
              light
              @click="signIn"
              width="100%"
            >
              Sign in
            </v-btn>
          </v-layout>
          <v-layout row class="bottom justify-center">
            <span
              class="mt-4 forgot"
              @click="forgotPassword"
            >
              Forgot password?
            </span>
          </v-layout>
        </v-form>
        <div class="auth-error" v-if="error">
          {{ error }}
        </div>
      </v-card-text>
    </v-container>
  </v-card>
</template>

<script>
/* eslint func-names: ["error", "never"] */
/* eslint object-shorthand: 0 */

import { Auth, Logger } from 'aws-amplify';
import EventBus from '@/utils/EventBus';

const logger = new Logger('LoginView');

export default {
  name: 'LogInView',
  theme: { dark: false },
  props: {
    mail: {
      type: String,
      required: false,
    },
    click: {
      type: Function,
      required: true,
    },
  },
  data() {
    return {
      show: false,
      password: '',
      error: '',
    };
  },
  mounted() {
    setTimeout(this.focusOnField, 1000);
  },
  computed: {
    username: {
      get: function () {
        return this.mail;
      },
      set: function (newval) {
        this.$emit('update:mail', newval);
      },
    },
  },
  methods: {
    signIn() {
      Auth.signIn(this.username, this.password)
        .then((data) => {
          let state = '';
          if (data.challengeName === 'SMS_MFA' || data.challengeName === 'SOFTWARE_TOKEN_MFA') {
            logger.warn(`${data.challengeName} NOT IMPLEMENTED`);
            EventBus.$emit('localUser', data);
            state = 'CONFIRM_SIGN_IN';
          } else if (data.challengeName === 'NEW_PASSWORD_REQUIRED') {
            EventBus.$emit('localUser', data);
            state = 'NEW_PASSWORD_REQUIRED';
          } else if (data.challengeName === 'MFA_SETUP') {
            EventBus.$emit('localUser', data);
            state = 'SET_MFA';
          } else {
            state = 'SIGNED_IN';
          }
          return EventBus.$emit('authState', state);
        })
        .catch((e) => this.setError(e));
    },
    forgotPassword() {
      EventBus.$emit('authState', 'FORGOT_PASSWORD');
    },
    setError(e) {
      this.error = e.message || e;
      logger.error(this.error);
    },
    focusOnField() {
      this.$refs.focusedField.focus();
    },
  },
};
</script>

<style scoped>
.auth-error {
  margin: 5px;
  padding: 3px;
  color: #E91300;
}
.bottom {
  justify-content: space-between;
  align-items: center;
}
.forgot {
  margin-right: 20px;
}
.forgot:hover {
  text-decoration: underline;
  cursor: pointer;
  color: #e66465;
}
</style>
